import { pick } from 'lodash'

const transformToUpdateDishTypeIgnoredDetailsArgs = data =>
  pick(data, ['isIgnored', 'courseTypeId'])

export default transformToUpdateDishTypeIgnoredDetailsArgs
